import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Admin/Manager always see the feature; workers only when the Configuration switch is ON. null = loading.
export function useStaffFlag(key) {
  const { user } = useAuth();
  const isWorker = user?.role === "Worker";
  const [on, setOn] = useState(isWorker ? null : true);
  useEffect(() => {
    if (!isWorker) { setOn(true); return; }
    api.get("/settings").then(r => setOn(!!r.data[key])).catch(() => setOn(false));
  }, [isWorker, key]);
  return on;
}

export const useLeaveVisible = () => useStaffFlag("leave_visible_to_staff");
export const usePayslipsVisible = () => useStaffFlag("payslips_visible_to_staff");
